export default __webpack_public_path__ + "static/media/icon-analytics.28b575ba.svg";